import moment from "moment";
import { useEffect, useState } from "react";
import Select from "react-select";
import { useGetNewsQuery } from "store/news/newsApi";
import ArrowPng from "../assets/images/ArrowLocation.png";
import LazyLoad from "components/LazyLoad";

function News() {
  const limit = 12;
  const [currentPage, setcurrentPage] = useState(1);
  const [newsItems, setnewsItems] = useState([]);
  const [sortBy, setsortBy] = useState({ value: "publish_date", label: "Latest" });

  const {
    data: news,
    isLoading,
    isFetching,
    refetch,
  } = useGetNewsQuery({ currentPage, limit, sortBy: sortBy?.value });

  useEffect(() => {
    if (news?.data?.length > 0) {
      if (currentPage > 1) {
        setnewsItems((prevItems) => [...prevItems, ...news?.data]);
      } else {
        setnewsItems(news?.data);
      }
    }
  }, [news]);

  useEffect(() => {
    refetch();
  }, [sortBy, currentPage]);

  const colourStyles = {
    menu: (provided) => ({
      ...provided,
      borderRadius: "0px",
      cursor: "pointer",
    }),
    menuList: (provided) => ({
      ...provided,
      padding: "0px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black", // 👈 text color
    }),
    control: (styles) => ({
      ...styles,
      backgroundColor: "transparent",
      borderColor: "black",
      borderRadius: 25,
      boxShadow: "none",
      minWidth: "140px",
      cursor: "default",
      padding: "0px 8px",
      caretColor: "transparent",
      pointerEvent: "none",
      userSelect: "none",
      ":hover": {
        borderColor: "black",
        boxShadow: "none",
        outline: "none",
      },
    }),
    option: (styles, { isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
            ? "#f2f2f2"
            : isFocused
              ? "#f2f2f2"
              : undefined,
        color: isDisabled ? "#ccc" : isSelected ? "#000" : "#000",
        cursor: isDisabled ? "not-allowed" : "default",

        ":active": {
          ...styles[":active"],
          backgroundColor: !isDisabled ? (isSelected ? "#f2f2f2" : "#f2f2f2") : undefined,
        },
      };
    },
    input: (provided) => ({
      ...provided,
      color: "black", // 👈 typing text
      cursor: "pointer",
    }),
    placeholder: (styles) => ({ ...styles, padding: "0 5px", paddingLeft: "15px" }),
    singleValue: (styles, { data }) => ({ ...styles, color: "black" }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
    }),
    clearIndicator: (provided, state) => ({
      ...provided,
      display: "none",
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: "black",
      padding: 4, // 👈 kam padding = thin arrow
      transform: "scale(0.8)",
    }),
    indicatorSeparator: (provided) => ({
      display: "none",
    }),
  };

  //console.log(news);

  const newsCards = newsItems?.map((item, index) => {
    return (
      <div className="news-item" key={`news-item_${index}`}>
        <a
          href={item?.attributes?.url}
          target="_blank"
          className="tumbnail-img hover-image-container"
        >
          <LazyLoad
            src={item?.attributes?.thumbnail_url}
            dataSrc={item?.attributes?.thumbnail_url}
          />
        </a>
        <div className="copy-wrap">
          <div className="top-wrap">
            {item?.attributes?.tag?.data?.attributes?.title && (
              <p className="title">{item.attributes.tag.data.attributes.title}</p>
            )}{" "}
            <a href={item?.attributes?.url} className="rolling-copy-wrap" target="_blank">
              <span className="news-title">{item?.attributes?.title}</span>{" "}
              <span className="arrow-wrapper-test rolling-copy-wrap-test">
                <img src={ArrowPng} />
              </span>
            </a>
          </div>
          <p className="date">{moment(item?.attributes?.publish_date).format("D MMMM YYYY")}</p>
        </div>
      </div>
    );
  });

  return (
    <div id="news" data-scroll-section>
      <div className="container">
        <div className="news-header">
          <h2 className="news-heading">news</h2>
          <div className="filter-wrapper">
            {/* <span className="label">Sort by</span> */}
            <Select
              value={sortBy}
              onChange={(input) => setsortBy(input)}
              options={[
                { value: "publish_date", label: "Latest" },
                { value: "view_count", label: "Popular" },
              ]}
              className="custom-select"
              styles={colourStyles}
            />
          </div>
        </div>
        {/* <div className="divider"></div> */}
        <div className="news-list">
          {isLoading ? (
            <div className="spinner spinner-news">
              <span></span>
            </div>
          ) : (
            newsCards
          )}
        </div>

        {currentPage < news?.meta?.pagination?.pageCount && (
          <div className="show-more-wrap">
            {isFetching ? (
              <div className="spinner spinner-works">
                <span></span>
              </div>
            ) : (
              <a
                className="show-more-button"
                onClick={() => setcurrentPage((prevPage) => prevPage + 1)}
              >
                Show More
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default News;
